import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import SSO from '@/plugins/sso'
import { getSSOConfiguration } from './config'
import { apolloProvider } from '@/services/apollo-service'

Vue.config.productionTip = false

const ssoConfig = getSSOConfiguration()

Vue.use(SSO, {
  ...ssoConfig,
  router,
  store
})

const vm = new Vue({
  router,
  store,
  vuetify,
  apolloProvider,
  render: h => h(App)
}).$mount('#app')

export default vm
